
// import React from 'react'
import { Routes, Route } from 'react-router-dom';
// import { useRoutes } from "react-router-dom";
import { URLS } from '../resources/constants'

import Header from '../layouts/Header'
import Login from '../scenes/Login'
import Dashboard from '../scenes/Dashboard'
import PrivateRoutes from '../hoc/PrivateRoutes';
import VersionUpgrade from '../hoc/VersionUpgrade';
import UserMappedRoutes from '../hoc/UserMappedAccount';
import COAExixts from '../hoc/COAExixts';
import BeginingBalanceExixts from '../hoc/BeginingBalanceExixts';
import MonthCloseDepositSalesPos from '../hoc/MonthCloseDepositSalesPos';
import BankTransaction from '../scenes/Transactions/BankTransactions';
import UserProfile from '../scenes/UserProfile';
import Budget from '../scenes/Budget';
import Settings from '../scenes/Settings';
import BalanceSheet from '../scenes/BalanceSheet';
import ChartOfAccounts from '../scenes/ChartOfAccounts';
import UserVerification from '../scenes/UserVerification';
import ExpenseGlClassification from '../scenes/GlClassification/ExpenseGlClassification/ExpenseGlClassification';
import ExpenseGlClassificationStatus from '../scenes/GlClassification/ExpenseGlClassification/ExpenseGlClassificationStatus';
import CreditCardGlClassificationStatus from '../scenes/GlClassification/CreditCardGlClassification/CreditCardGlClassificationStatus';
import CreditCardGlClassification from '../scenes/GlClassification/CreditCardGlClassification/CreditCardGlClassification';
import SalesGlClassification from '../scenes/GlClassification/SalesGlClassification/SalesGlClassification';
import SalesGlClassificationStatus from '../scenes/GlClassification/SalesGlClassification/SalesGlClassificationStatus';
// import CreditGlClassification from '../scenes/GlClassification/CreditGlClassification';
import RevenueGlClassification from '../scenes/GlClassification/RevenueGlClassification/RevenueGlClassification';
import RevenueGlClassificationStatus from '../scenes/GlClassification/RevenueGlClassification/RevenueGlClassificationStatus';
import BankFeed from '../scenes/GlClassification/BankFeed';
import SaleTransaction from '../scenes/Transactions/SalesTransactions';
import ViewRegister from '../scenes/GlClassification/ViewRegister';
import ProfitLoss from '../scenes/ProfitLoss';
import FourThreeThreeB from '../scenes/FourThreeThreeB';
import PersonalBalanceSheet from '../scenes/PersonalBalanceSheet';
import PersonalIncomeStatement from '../scenes/PersonalIncomeStatement';
import BankReconcile from '../scenes/BankReconcile';
import BankReconcileTxn from '../scenes/BankReconcile/BankReconcileTxn';
import StatementOfCashFlow from '../scenes/StatementOfCashFlow';
import UserStpesRoutes from '../hoc/UserStpesCheck';
import NotFound from '../scenes/NotFound';
import BusinessRatio from '../scenes/BusinesssRatio';
import Sales from '../scenes/Sales';
import OpenningBalance from '../scenes/OpenningBalance';
import ThirdPartyIntegrationList from '../scenes/ThirdParty';
import ThirdPartyConnection from '../scenes/ThirdParty/Connection';
import QuickBookCallback from '../scenes/ThirdParty/QuickBookCallback';
import QuickBookDashboard from '../scenes/ThirdParty/QuickBook/Dashboard';
import QBCOAClassification from '../scenes/ThirdParty/QuickBook/QBCOAClassification';
import QBBeginningBalanceClassification from '../scenes/ThirdParty/QuickBook/BBClassification';
import QBBalanceSheetPLList from '../scenes/ThirdParty/QuickBook/QBBalanceSheetPLList';
import QBPLList from '../scenes/ThirdParty/QuickBook/QBPLList';
import QBBSList from '../scenes/ThirdParty/QuickBook/QBBSList';

import GustoIntegrationList from '../scenes/Gusto';
import GustoConnection from '../scenes/Gusto/Connection';
import GustoDashboard from '../scenes/Gusto/Dashboard';
import GustoCallback from '../scenes/Gusto/GustoCallback';
import GustoChartOfAccount from '../scenes/Gusto/ChartOfAccounts';
import PayrollJournalList from '../scenes/Gusto/PayrollJournalList';

const Router: React.FC = () => {
    return (
        <div>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    <Route element={<Header />} path="/">
                        <Route element={<Dashboard />} path={URLS.HOME} />
                        <Route element={<Dashboard />} path={URLS.DASHBOARD} />
                        {/* <Route element={<VersionUpgrade />}> */}
                            <Route element={<COAExixts />}>
                                <Route element={<OpenningBalance />} path={URLS.OPENNING_BALANCE} />
                                {/* <Route element={<BeginingBalanceExixts />}> */}
                                <Route element={<MonthCloseDepositSalesPos />}>
                                    <Route element={<UserStpesRoutes />}>
                                        <Route element={<BankTransaction />} path={URLS.BANK_TRANSACTION} />
                                        <Route element={<UserProfile />} path={URLS.USERPROFILE} />
                                        <Route element={<Settings />} path={URLS.SETTINGS} />
                                        <Route element={<BalanceSheet />} path={URLS.BALANCESHEET} />
                                        <Route element={<Budget />} path={URLS.BUDGET} />
                                        <Route element={<BankFeed />} path={URLS.BANK_FEED} />
                                        <Route element={<SaleTransaction />} path={URLS.SALES_TRANSACTION} />
                                        <Route element={<ViewRegister />} path={URLS.VIEW_REGISTER} />
                                        <Route element={<ProfitLoss />} path={URLS.PROFITLOSS} />
                                        <Route element={<FourThreeThreeB />} path={URLS.FOURTHREETHREEB} />
                                        <Route element={<PersonalBalanceSheet />} path={URLS.PERSONAL_BALANCE_SHEET} />
                                        <Route element={<PersonalIncomeStatement />} path={URLS.PERSONAL_INCOME_STATMENT} />
                                        <Route element={<StatementOfCashFlow />} path={URLS.STATEMENT_OF_CASH_FLOW} />
                                        <Route element={<BankReconcile />} path={URLS.BANK_RECONCILE} />
                                        <Route element={<BankReconcileTxn />} path={URLS.BANK_RECONCILE_TRANSACTIONS} />
                                        <Route element={<BusinessRatio />} path={URLS.BUSINESS_RATIO} />
                                        <Route element={<Sales />} path={URLS.SALES} />
                                    </Route>
                                    <Route element={<UserMappedRoutes />}>
                                        <Route element={<ExpenseGlClassification />} path={URLS.EXPENSE_GL_CLASSIFICATION} />
                                        <Route element={<ExpenseGlClassificationStatus />} path={URLS.EXPENSE_GL_CLASSIFICATION_STATUS} />

                                        <Route element={<RevenueGlClassification />} path={URLS.REVENUE_GL_CLASSIFICATION} />
                                        <Route element={<RevenueGlClassificationStatus />} path={URLS.REVENUE_GL_CLASSIFICATION_STATUS} />

                                        <Route element={<CreditCardGlClassificationStatus/>} path={URLS.CREDIT_CARD_GL_CLASSIFICATION_STATUS} />
                                        <Route element={<CreditCardGlClassification/>} path={URLS.CREDIT_CARD_GL_CLASSIFICATION} />

                                        <Route element={<SalesGlClassification />} path={URLS.SALES_GL_CLASSIFICATION} />
                                        <Route element={<SalesGlClassificationStatus />} path={URLS.SALES_GL_CLASSIFICATION_STATUS} />
                                    </Route>
                                {/* </Route> */}
                                </Route>
                            </Route>
                            <Route element={<ChartOfAccounts />} path={URLS.CHARTACCOUNT} />
                        {/* </Route> */}
                        <Route element={<ThirdPartyIntegrationList />} path={URLS.THIRD_PARTY} />
                        <Route element={<ThirdPartyConnection />} path={URLS.THIRD_PARTY_CONNECTION} />
                        <Route element={<QuickBookCallback />} path={URLS.QUICKBOOK_CALLBACK} />
                        <Route element={<QuickBookDashboard />} path={URLS.QUICKBOOK_DASHBOARD} />
                        <Route element={<QBCOAClassification />} path={URLS.QUICKBOOK_COA} />
                        <Route element={<QBBeginningBalanceClassification />} path={URLS.QUICKBOOK_BB} />
                        <Route element={<QBBalanceSheetPLList />} path={URLS.QUICKBOOK_BS_PL} />
                        <Route element={<QBBSList />} path={URLS.QUICKBOOK_BS} />
                        <Route element={<QBPLList />} path={URLS.QUICKBOOK_PL} />

                        <Route element={<GustoIntegrationList />} path={URLS.GUSTO_HOME} />
                        <Route element={<GustoConnection />} path={URLS.GUSTO_CONNECTION} />
                        <Route element={<GustoDashboard />} path={URLS.GUSTO_DASHBOARD} />
                        <Route element={<GustoCallback />} path={URLS.GUSTO_CALLBACK} />
                        <Route element={<GustoChartOfAccount />} path={URLS.GUSTO_CHART_OF_ACCOUNT} />
                        <Route element={<PayrollJournalList />} path={URLS.GUSTO_PAYROLL_JOURNAL_LIST} />
                        
                    </Route>
                </Route>
                <Route element={<Login />} path={URLS.LOGIN} />
                <Route element={<UserVerification />} path={URLS.USER_VERIFICATION} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </div>
    )
}

export default Router;